import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appClickOutsideAssignBlock]',
})
export class ClickOutsideAssignBlockDirective {
    constructor(private elementRef: ElementRef) {}

    @Output() appClickOutsideAssignBlock = new EventEmitter();

    @HostListener('document:click', ['$event.target'])
    onClick(target: EventTarget): void {
        if (!(target instanceof Element)) {
            return;
        }

        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside && !target.closest('.assign-block') && !target.closest('typeahead-container')) {
            this.appClickOutsideAssignBlock.emit(null);
        }
    }
}
